module.exports = __webpack_public_path__ + "static/media/facilitator_clues.048d48d1.pdf";